import React, { useState, useEffect, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import queryString from 'query-string'

import { getAllPlansGroups } from 'redux/actions'
import { REGISTER_INFO_PERSONAL, REGISTER_INFO_GROUP } from 'settings/_routesSettings'
import { history } from 'routers/AppRouter'

import { SignupContext } from 'contexts/SignupContext'

import Register from '../Register'
import { stepsList } from './Steps'

import PlanGroupsSelect from '../components/PlanGroupsSelect'
import ToggleButton from 'components/ToggleButton'
import { Typography, Button, Spinner } from '@telavita-core/react-design-kit'

const GroupPlanSelection = () => {

  const { setPlanGroup } = useContext(SignupContext)

  const dispatch = useDispatch()

  const [isLoadingGroupPlans, setIsLoadingGroupPlans] = useState(false)
  const [isParticular, setIsParticular] = useState(null)
  const [groupPlan, setGroupPlan] = useState(null)

  const plans = useSelector(state => state.plans.allPlansGroups.plan_groups)

  const groupPlans = plans
    ? plans.filter((plan) => plan.self_register).map(plan => {
      return {
        id: plan.code,
        name: plan.name
      }
    }).sort((a, b) => (a.name > b.name) ? 1 : -1)
    : []

  useEffect(() => {
    async function checkQueryString() {
      const groupPlan = queryString.parse(window.location.search).group_plan
      if (groupPlan) {
        await setIsParticular(false)
        await setGroupPlan(groupPlan)
        setPlanGroup({
          code: groupPlan,
          name: getPlanGroupNameByCode(groupPlan),
          category: getPlanGroupCategoryByCode(groupPlan),
        })
        handleSubmitSelection()
      }
      const type = queryString.parse(window.location.search).type
      if (type) {
        if (type === 'plan') {
          await setIsParticular(false)
        } else if (type === 'private') {
          await setIsParticular(true)
        }
      }
    }

    function loadGroupPlans() {
      setIsLoadingGroupPlans(true)
      dispatch(getAllPlansGroups())
        .then(() => setIsLoadingGroupPlans(false))
    }

    checkQueryString()
    loadGroupPlans()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleIsParticularClick(value) {
    setIsParticular(value)
  }

  function handleGroupPlanDropdown(code) {
    setGroupPlan(code)
  }

  function handleSubmitSelection() {
    if (isParticular){
      setPlanGroup({
        code: null,
        name: '',
        category: null,
      })
      history.push(REGISTER_INFO_PERSONAL)
    }else{
      setPlanGroup({
        code: groupPlan,
        name: getPlanGroupNameByCode(groupPlan),
        category: getPlanGroupCategoryByCode(groupPlan),
      })
      history.push(`${REGISTER_INFO_GROUP}?group_plan=${groupPlan}`)
    }
  }

  function getPlanGroupNameByCode(code) {
    const planGroup = plans.find(planGroup => planGroup.code === code)
    const { name } = planGroup
    return name
  }

  function getPlanGroupCategoryByCode(code) {
    const planGroup = plans.find(planGroup => planGroup.code === code)
    const { category } = planGroup
    return category
  }

  function handleButtonDisable() {
    if (isParticular === null) return true
    if (isParticular === false && groupPlan === null) return true
    return false
  }

  return (
    <Register
      showStepper={false}
      showLoginInfo={true}
      currentStep={stepsList.GROUP_SELECTION}
    >
      <div className="GroupPlanSelection">
        <div className="GroupPlanSelection__Title">
          <Typography
            variant='content2'
          >
            Escolha o seu tipo de conta:
          </Typography>
        </div>
        <div className="GroupPlanSelection__Selectors">
          <ToggleButton
            isActive={ isParticular === false }
            handleClick={ () => handleIsParticularClick(false) }
            itemTitle="Convênio"
            iconName="PlansBigger"
            data-cy="signup-toggle-convenio"
            isFilterAll
          />
          <ToggleButton
            isActive={ isParticular === true }
            handleClick={ () => handleIsParticularClick(true) }
            itemTitle="Particular"
            iconName="User"
            data-cy="signup-toggle-particular"
            isFilterAll
          />
        </div>
        <div className="GroupPlanSelection__Dropdown">
          {
            isParticular === false && (
              isLoadingGroupPlans
                ? <div className='GroupPlanSelection__Dropdown__Spinner'>
                  <Spinner height="48px" spinnerStyle={{marginBottom: 20}} />
                </div>
                : (
                  <PlanGroupsSelect
                    id='signup-plan'
                    options={groupPlans}
                    selectedId={groupPlan}
                    onSelect={(code) => handleGroupPlanDropdown(code)}
                    floatingLabel='Planos e empresas disponíveis'
                    emptyOptionsMessage='Nenhum resultado. Verifique sua digitação.'
                  />
                )
            )
          }
        </div>
        <div className="GroupPlanSelection__Button">
          <Button
            variant='contained'
            uppercase={false}
            disabled={handleButtonDisable()}
            onClick={handleSubmitSelection}
            data-cy='signup-next-step'
            inlineStyles={{
              width: '100%'
            }}
          >
            Próximo
          </Button>
        </div>
      </div>
    </Register>
  )
}

export default GroupPlanSelection
